import { jwtDecode } from "jwt-decode";

export const ACCESS_TOKEN_KEY = "access_token";
export const REDIRECT_LOGOUT_KEY = "redirect_logout";

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}

/**
 * True when JWT says the user still has a system-generated password.
 * Missing claim (older tokens) is treated as already changed.
 */
export function needsPasswordChange() {
  const token = getAccessToken();
  if (!token) {
    return false;
  }
  try {
    const decoded = jwtDecode(token);
    return decoded?.is_pwd_changed === false;
  } catch {
    return false;
  }
}

export function getTokenEmail() {
  const token = getAccessToken();
  if (!token) {
    return null;
  }
  try {
    const decoded = jwtDecode(token);
    return decoded?.email || null;
  } catch {
    return null;
  }
}

/**
 * Clears the post-logout flag and returns whether the current navigation
 * should bypass the auth check (used during logout redirect flow).
 */
export function consumeRedirectLogoutFlag() {
  const shouldBypassAuth = Boolean(localStorage.getItem(REDIRECT_LOGOUT_KEY));
  if (shouldBypassAuth) {
    localStorage.removeItem(REDIRECT_LOGOUT_KEY);
  }
  return shouldBypassAuth;
}

export function buildLoginRedirectPath(pathname, search = "") {
  return `${pathname}${search}`;
}

export function getRedirectTarget(search = "") {
  return new URLSearchParams(search).get("redirect");
}

/**
 * Only allow in-app relative paths (prevents open redirects and /login loops).
 */
export function getSafeRedirectTarget(search = "") {
  const redirect = getRedirectTarget(search);

  if (!redirect || !redirect.startsWith("/") || redirect.startsWith("//")) {
    return null;
  }

  if (redirect === "/login" || redirect.startsWith("/login?")) {
    return null;
  }

  return redirect;
}

export function buildLoginUrl(pathname, search = "") {
  const redirectPath = buildLoginRedirectPath(pathname, search);
  const params = new URLSearchParams();
  params.set("redirect", redirectPath);
  return `/login?${params.toString()}`;
}
